import type { ISectionOptions } from 'docx';
import { Footer } from 'docx';
import type { Editor } from 'slate';

import type { DocumentContext } from './internal';
import { createDocxChildren } from './internal';
import { FooterType, Queries } from '../../../slate-api';

export function createDocxFooters(
  editor: Editor,
  options: { context: DocumentContext }
): ISectionOptions['footers'] {
  /**
   * ToDo: Fix links in footers.  Broken due to bug in DOCX library.  See GitHub issue - https://github.com/dolanmiu/docx/issues/532.
   *  Ticket - https://arity.atlassian.net/browse/AR-860.
   */
  const footersEntry = Queries.getFootersElement(editor);
  if (!footersEntry) return;

  const defaultFooterEntry = Queries.getHeaderOrFooter({
    editor,
    partEntry: footersEntry,
    type: FooterType.Default,
  });
  const firstPageFooterEntry = Queries.getHeaderOrFooter({
    editor,
    partEntry: footersEntry,
    type: FooterType.FirstPage,
  });
  const evenFooterEntry = Queries.getHeaderOrFooter({
    editor,
    partEntry: footersEntry,
    type: FooterType.Even,
  });

  return {
    default: new Footer({
      children: createDocxChildren(defaultFooterEntry, options),
    }),
    even: new Footer({
      children: createDocxChildren(evenFooterEntry, options),
    }),
    first: new Footer({
      children: createDocxChildren(firstPageFooterEntry, options),
    }),
  };
}
